document.documentElement.classList.add('js');

const header = document.querySelector('.site-header');
const onScrollHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 40);

const layers = Array.from(document.querySelectorAll('.atmos-layer'));
const CEILING = [1, 0.62, 0.65, 0.78, 0.75, 0.9, 1];
let marks = [];

function measure() {
  marks = Array.from(document.querySelectorAll('[data-haze]')).map((el) => {
    const r = el.getBoundingClientRect();
    return { centre: r.top + window.scrollY + r.height / 2, layer: Number(el.dataset.haze) };
  }).sort((a, b) => a.centre - b.centre);
}

const smooth = (t) => t * t * (3 - 2 * t);

function paint() {
  if (!marks.length) return;
  const eye = window.scrollY + window.innerHeight / 2;
  const weight = layers.map(() => 0);

  if (eye <= marks[0].centre) {
    weight[marks[0].layer] = 1;
  } else if (eye >= marks[marks.length - 1].centre) {
    weight[marks[marks.length - 1].layer] = 1;
  } else {
    for (let i = 0; i < marks.length - 1; i++) {
      const a = marks[i], b = marks[i + 1];
      if (eye >= a.centre && eye <= b.centre) {
        const t = smooth((eye - a.centre) / (b.centre - a.centre));
        weight[a.layer] = 1 - t;
        weight[b.layer] = t;
        break;
      }
    }
  }

  const capped = weight.map((w, i) => w * CEILING[i]);
  const total = capped.reduce((s, v) => s + v, 0);
  const norm = total > 0 ? capped.map((v) => v / total) : capped;
  layers.forEach((el, i) => { el.style.opacity = norm[i].toFixed(3); });
  header.classList.toggle('on-dark', norm[6] > 0.5);
}

let queued = false;
function onScroll() {
  onScrollHeader();
  if (queued) return;
  queued = true;
  requestAnimationFrame(() => { paint(); queued = false; });
}

measure();
onScroll();
window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', () => { measure(); paint(); });
window.addEventListener('load', () => { measure(); paint(); });

const reveals = document.querySelectorAll('.reveal');
reveals.forEach((el) => {
  if (el.getBoundingClientRect().top < window.innerHeight) {
    el.style.transition = 'none';
    el.classList.add('is-visible');
    requestAnimationFrame(() => { el.style.transition = ''; });
  }
});
if ('IntersectionObserver' in window) {
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  reveals.forEach((el) => io.observe(el));
} else {
  reveals.forEach((el) => el.classList.add('is-visible'));
}

/* Signup is a normal Shopify customer-form post (it needs the browser's own submit for the CAPTCHA token).
   Validate first; only stop the submit if the address is invalid. After the post, Shopify re-renders the page
   with the thank-you message inside the form, so bring the reader back to it. */
const form = document.getElementById('notify-form');
const status = document.getElementById('form-status');
if (form) {
  form.addEventListener('submit', (e) => {
    const field = form.elements['contact[email]'];
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value.trim())) {
      e.preventDefault();
      status.textContent = 'Please enter a valid email address.';
      field.focus();
    }
  });
  if (document.getElementById('form-posted')) {
    document.getElementById('notify').scrollIntoView();
  }
}